// extracted by mini-css-extract-plugin
module.exports = {"loader-overlay":"loader-overlay_loader-overlay__Mw1kK"};